// Simple browser-compatible EventEmitter
type EventCallback = (...args: unknown[]) => void

export class EventEmitter {
  private events: Map<string, Set<EventCallback>> = new Map()

  on(event: string, listener: EventCallback) {
    if (!this.events.has(event)) {
      this.events.set(event, new Set())
    }
    this.events.get(event)!.add(listener)
    return this
  }

  off(event: string, listener: EventCallback) {
    const listeners = this.events.get(event)
    if (listeners) {
      listeners.delete(listener)
    }
    return this
  }

  emit(event: string, ...args: unknown[]) {
    const listeners = this.events.get(event)
    if (listeners) {
      listeners.forEach(listener => {
        try {
          listener(...args)
        } catch (error) {
          console.error(`Error in event listener for ${event}:`, error)
        }
      })
    }
    return this
  }

  removeAllListeners(event?: string) {
    if (event) {
      this.events.delete(event)
    } else {
      this.events.clear()
    }
    return this
  }
}